import React from 'react';

import { Comments } from '../Comments.component';

export const CommentsDefault = ({ ...props }) => {
  return (
    <Comments {...props}>
      <Comments.TextArea />
      <Comments.EmptyAnswer />
    </Comments>
  );
};
